import React, { useState } from "react";
import HandleWarehouseComplaintModalContent from "./HandleWarehouseComplaintModal";
import { COLORS } from "rylak-common/src/constants";
import { TurnrButton } from "~/components/buttons/TurnrButton";
import { StatusChipActionModalButton } from "~/components/chips/StatusChipActionModalButton.jsx";
import TurnrModal from "~/components/modals/TurnrModal.jsx";

export function HandleWarehouseComplaintReloadButton(props) {
    const { warehouseReport, appProps } = props;

    const [handleComplaintModalOpen, setHandleComplaintModalOpen] = useState(false);

    return (
        <>
            <TurnrModal open={handleComplaintModalOpen} onClose={setHandleComplaintModalOpen} appProps={appProps}>
                <HandleWarehouseComplaintModalContent warehouseReportId={warehouseReport?.id} appProps={appProps} onSuccess={() => appProps.reloadPage()} onClose={setHandleComplaintModalOpen} />
            </TurnrModal>
            <TurnrButton iconSize={"large"} size={"small"} variant={"contained"} color={COLORS.ACTION} onClick={() => setHandleComplaintModalOpen(true)}>
                Handle warehouse report
            </TurnrButton>
        </>
    );
}

export function HandleWarehouseComplaintSmartButton(props) {
    const { warehouseReport, appProps, children } = props;
    return (
        <StatusChipActionModalButton
            appProps={appProps}
            ModalComponent={HandleWarehouseComplaintModalContent}
            modalComponentProps={{
                closeOnSubmit: true,
                warehouseReportId: warehouseReport?.id,
            }}
        >
            {children}
        </StatusChipActionModalButton>
    );
}
